const CONTACTS = {
  PHONE: "+1(718) 687-8900",
};

export default CONTACTS;
